export const SNACKBAR_DURATION = 2000;
